import { render } from "./OrderListPage.vue?vue&type=template&id=14cee792"
import script from "./OrderListPage.vue?vue&type=script&lang=ts"
export * from "./OrderListPage.vue?vue&type=script&lang=ts"
script.render = render

export default script